import React from 'react'
import { observer } from 'mobx-react-lite'
import TableCell from '@mui/material/TableCell'
import { CustomTableStore, useCustomTableStore } from '../CustomTableStore'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import ArrowRightIcon from '@mui/icons-material/ArrowRight'
import useCustomTableRenderLog from '../hooks/useCustomTableRenderLog'
import useStore from 'reusable/mobx-store-utils'
import { useTheme } from 'theme/useTheme'

export const CustomTableHeaderCollapseCell = observer(function CustomTableHeaderCollapseCell<RowData extends AnyObject, RowStore>() {
   useCustomTableRenderLog('CustomTableHeaderCollapseCell')
   const customTableStore = useCustomTableStore<CustomTableStore<RowData, RowStore>>()
   const theme = useTheme()

   const localStore = useStore(
      sp => ({
         get headerCellStyle() {
            return {
               position: 'sticky',
               top: customTableStore.headerCellTopValue,
               zIndex: 1,
               whiteSpace: 'nowrap',
               width: '1%',
               padding: theme.spacing(0, 1, 0, 1),
               borderCollapse: 'separate',
            } as React.CSSProperties
         },
         get open() {
            if (customTableStore.sp.showCollapseAllButton === false) {
               return undefined
            }

            for (const localRow of customTableStore.localRows) {
               if (localRow.collapsibleConfig.rowHasCollapsibleDetail) {
                  return localRow.collapsibleOpen
               }
            }

            return undefined
         },
         get tooltip() {
            return localStore.open ? 'Close All' : 'Open All'
         },
         toggle() {
            customTableStore.loading = true
            setTimeout(() => {
               const open = !localStore.open
               for (const localRow of customTableStore.localRows) {
                  if (localRow.collapsibleConfig.rowHasCollapsibleDetail) {
                     localRow.collapsibleOpen = open
                  }
               }
               customTableStore.loading = false
            })
         },
         get buttonStyle(): React.CSSProperties {
            return { margin: '0px' }
         },
      }),
      {}
   )

   return customTableStore.hasCollapsibleRowDetail ? (
      <TableCell variant="head" style={localStore.headerCellStyle} align="center">
         {localStore.open !== undefined && (
            <Tooltip title={localStore.tooltip}>
               <IconButton onClick={localStore.toggle} style={localStore.buttonStyle} size={customTableStore.size}>
                  {localStore.open ? <ArrowDropDownIcon /> : <ArrowRightIcon />}
               </IconButton>
            </Tooltip>
         )}
      </TableCell>
   ) : null
})
